import { LegalDocument } from '@/components/LegalDocument'

export function PrivacyPolicy() {
  return <LegalDocument documentKey="privacy" />
}
